module.exports = __webpack_public_path__ + "static/media/Andrew Greatbatch.2384065a.JPG";